import { SET_CACHE } from '../actions/gCache';

const initialState = {
    data : {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_CACHE: {
            return {
                ...state,
                data : {
                    ...state.data,
                    ...action.payload
                }
            };
        }
        default: {
            return state;
        }
    }
};
